module.exports = __webpack_public_path__ + "img/default-homepage-banner.e122e32d.jpg";